// ---------------------------------------------------------------------------
// LiveMonitoringPage — SP-5f Task D1
// Route dedicata `/live`. Il contenuto vero vive in LiveMonitoringPanel
// (riusato anche dalla Dashboard/Home). Qui resta solo il page chrome.
// ---------------------------------------------------------------------------

import { LiveMonitoringPanel } from '../../components/live/LiveMonitoringPanel';
import { PageHeading } from '../../layouts/PageHeading';

export default function LiveMonitoringPage() {
  return (
    <div>
      <PageHeading scope="Stato attuale" />
      <LiveMonitoringPanel />
    </div>
  );
}
